module.exports = __webpack_public_path__ + "./docs/img/select_chevron_down.d5702ce40a85c4004dd5d497305a3290.svg";